import { useState } from "react";
const Addtask = ( { onAdd }) => {
    const [ text , setText] = useState('')
    const [ day, setDay ] = useState('')
    const [ reminder , setReminder ] = useState(false)
   
 
    // onSubmit
    const onSubmit = (e) => {
         e.preventDefault()

         if(!text) {
             alert('please add a task')
             return
         }

         onAdd({ text, day ,reminder})

         setText('')
         setDay('')
         setReminder(false)
    }

    return (
       <form className='add-form' onSubmit={ onSubmit }>
           <div className='form-control'>
               <label>Task</label>
               <input type="text" placeholder='Add Task' value={text} onChange={(e) => setText(e.target.value)}/>
           </div>

           <div className='form-control'>
               <label>Date & Time</label>
               <input type="text" placeholder='Add Date & Time' value={day} onChange={(e) => setDay(e.target.value)} />
           </div>

           <div className='form-control  form-control-check'>
               <label>Set Reminder</label>
               <input style={{color:'green'}} type="checkbox" checked={ reminder } value={reminder} onChange={(e) => setReminder(e.currentTarget.checked)} />
           </div>

           <input type="submit" className="btn btn-block" value="Save Task" />

       </form>
    )
}

export default Addtask
